const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff         : string = "/api";

export const ShippingQuery: any = {
    UpdateStoreToSellerShipmentStatusByCargoShipmentCode:
        Backofficebff + '/v1/shipping/UpdateStoreToSellerShipmentStatusByCargoShipmentCode',
    SendShippingListNosRpaMail: Backofficebff + '/v1/rpasender/sendshippinglistnosrpamail',
    GetShippingListStatusHistory: Backofficebff + '/v1/Shipping/get-shipping-list-status-history',
    UpdateShippingListStatusForReShipping: Backofficebff + '/v1/rpasender/updateshippingliststatusforreshipping',
    CheckRpaStatusByShippingListNumbersRest: Backofficebff + '/v1/rpasender/check-rpa-status-by-shipping-list-numbers',
    GetShippingCompanyCostForDesi: Backofficebff + '/v1/shipping/get-shipping-company-cost-for-desi',
    GetSellerShipmentCosts: Backofficebff + '/v1/shipping/get-seller-shipment-cost',
};
